<template>
	<div id="content">
		<!-- <Header :title="title"/> -->
		<div v-html="title" id="agreement"></div>
	</div>
</template>

<script>
	import { Toast } from 'vant';
	
	export default{
		
		data(){
		  return {
			title:'',
			url: '', // 标题
		  }
		},
		created() {
			this.content()
		},
		// mounted() {
		// 	const oIframe = document.getElementById('bdIframe');
		// 	const deviceWidth = document.documentElement.clientWidth;
		// 	const deviceHeight = document.documentElement.clientHeight;
		// 	oIframe.style.width = (Number(deviceWidth)) + 'px'; //数字是页面布局宽度差值
		// 	oIframe.style.height = (Number(deviceHeight)) + 'px'; //数字是页面布局高度差
		// 	console.log(oIframe.style.width,oIframe.style.height );

		// },
		methods:{
			async content(){
				let result = await this.$API.getContent(this.$route.params.type,this.$route.params.corpId)
				 if(result.msg == '成功'){
				   this.title = result.data[0].content
				//    this.url = result.data[0].url
				//    let url = result.data[0].url.split('apis/')
				//    this.url = 'https://cloud.zhongjianedu.com/apis/'+url[1]
				 }else{
					Toast('数据获取失败')
				 }
			}	
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	#agreement
		margin 15px
</style>
